"use client";

import { c as _c } from "react/compiler-runtime";
import { useChangeAnimation } from "../../hooks";
import { InlineFlex } from "../InlineFlex";
export function ChangeAnimation(t0) {
  const $ = _c(9);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== rest) {
    t1 = {
      ...rest
    };
    $[3] = rest;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    animationClassName,
    rerenderKey
  } = useChangeAnimation(t1);
  let t2;
  if ($[5] !== animationClassName || $[6] !== children || $[7] !== rerenderKey) {
    t2 = <InlineFlex className={animationClassName} key={rerenderKey}>{children}</InlineFlex>;
    $[5] = animationClassName;
    $[6] = children;
    $[7] = rerenderKey;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}